
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/solutions/[slug]",
      function () {
        return require("private-next-pages/preview/solutions/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/solutions/[slug]"])
      });
    }
  